"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewSeat = function NewSeat() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "20",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.19229 4.28847C4.68717 4.28847 4.2532 4.10706 3.89039 3.74424C3.52757 3.38142 3.34616 2.94746\n3.34616 2.44234C3.34616 1.93721 3.52757 1.50323 3.89039 1.14042C4.2532 0.777599 4.68717 0.596191\n5.19229 0.596191C5.69742 0.596191 6.1314 0.777599 6.49421 1.14042C6.85703 1.50323 7.03844 1.93721\n7.03844 2.44234C7.03844 2.94746 6.85703 3.38142 6.49421 3.74424C6.1314 4.10706 5.69742 4.28847\n5.19229 4.28847ZM11 17.5H4.80004C4.2949 17.5 3.83561 17.3282 3.42216 16.9846C3.0087 16.641 2.75005\n16.2166 2.64621 15.7115L0.519287 4.99999H2.05001L4.19231 15.6923C4.21155 15.7692 4.25802 15.8397\n4.33174 15.9038C4.40547 15.9679 4.4808 16 4.55774 16H11V17.5ZM16.2885 19.6923L13.5615\n15H6.47691C6.05128 15 5.68494 14.8718 5.37789 14.6154C5.07085 14.359 4.87054 14.0244 4.77694\n13.6115L3.63849 8.12692C3.47439 7.38462 3.64585 6.73879 4.15289 6.18944C4.65994 5.64007 5.26539\n5.36539 5.96924 5.36539C6.49487 5.36539 6.97435 5.52277 7.40769 5.83752C7.841 6.15225 8.11792\n6.58077 8.23844 7.12309L9.39614 12.5H12.8769C13.182 12.5 13.4654 12.5789 13.7269 12.7366C13.9884\n12.8942 14.2013 13.1103 14.3654 13.3846L17.5961 18.9423L16.2885 19.6923Z",
    fill: "#6E6D71"
  }));
};
var _default = NewSeat;
exports.default = _default;